import { render } from "./card-text.vue?vue&type=template&id=997a450c&scoped=true&ts=true"
import script from "./card-text.vue?vue&type=script&lang=ts"
export * from "./card-text.vue?vue&type=script&lang=ts"

import "./card-text.vue?vue&type=style&index=0&id=997a450c&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997a450c"]])

export default __exports__